class ScrollUp {
  simpleModule: HTMLElement | null;
  scrollButton: HTMLButtonElement | null;

  constructor() {
  
    this.scrollButton = document.querySelector('.footer__up');

    if (this.scrollButton) {
      this.initScrollToTop();
    }
  }

  initScrollToTop() {
    this.scrollButton!.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }
}

export const simple = new ScrollUp();
